import { z } from 'zod';
import {
    getDefaults,
    MAX_INPUT_TEXT_LENGTH,
    MAX_READABLE_DECIMAL,
    NumberFormatting,
    Validation,
} from '@mews/framework';

export const getCashierTransactionValidationSchema = (
    cashierCurrencies: string[],
    numberLocalizationInfo: NumberFormatting
) => {
    const currencyDefaultValue = cashierCurrencies.length === 1 ? cashierCurrencies[0] : '';
    return z.object({
        currency: Validation.String.Required.default(currencyDefaultValue),
        type: Validation.String.Required,
        value: Validation.Number.LocalizedUpperBoundNumber({
            numberCultureInfo: numberLocalizationInfo,
            upperBound: MAX_READABLE_DECIMAL,
        }).pipe(
            z
                .number()
                .positive()
                .transform((val) => val.toString())
        ),
        notes: Validation.String.Required.max(MAX_INPUT_TEXT_LENGTH),
    });
};

export const getCashierTransactionFormDefaultValues = (
    cashierCurrencies: string[],
    numberLocalizationInfo: NumberFormatting
) =>
    getDefaults(
        getCashierTransactionValidationSchema(cashierCurrencies, numberLocalizationInfo)
    ) as CashierTransactionFormValues;

export type CashierTransactionFormValues = z.infer<ReturnType<typeof getCashierTransactionValidationSchema>>;
